// THIS IS AN AUTOGENERATED FILE. DO NOT MODIFY.
import { createIcon } from './utils/createIcon';

export const ArrowLeft = createIcon(
  <path
    clipRule="evenodd"
    d="M10.4904 18.003C10.1389 18.3545 9.56903 18.3545 9.21756 18.003L4.35101 13.1365C4.18223 12.9678 4.0874 12.7388 4.0874 12.5002C4.0874 12.2615 4.18222 12.0325 4.35101 11.8638L9.21755 6.99721C9.56903 6.64574 10.1389 6.64574 10.4903 6.99722C10.8418 7.34869 10.8418 7.91854 10.4903 8.27001L7.1602 11.6001L19.0126 11.6001C19.5097 11.6001 19.9126 12.0031 19.9126 12.5001C19.9126 12.9972 19.5097 13.4001 19.0126 13.4001L7.16022 13.4001L10.4903 16.7302C10.8418 17.0817 10.8418 17.6515 10.4904 18.003Z"
    fillRule="evenodd"
  />,
);
